import { faPenToSquare } from "@fortawesome/pro-regular-svg-icons"
import { translate } from "app/language/service"
import { FORECAST_ORDER_NAME, IOrder } from "order/model"
import { openEditOrderPopup } from "order/tools/form"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { ListActionButton } from "ui/components/main-layout/ListActionButton"

interface IOrderListActionProps {
  order: IOrder
}

export const OrderListAction = React.memo(({ order }: IOrderListActionProps) => {
  if (order.name === FORECAST_ORDER_NAME) {
    return null
  }
  return (
    <FlexBox
      sx={{
        gap: ".5rem",
        fontSize: "1.5rem"
      }}>
      <ListActionButton
        icon={faPenToSquare}
        tooltip={translate("order.edit")}
        onClick={() => openEditOrderPopup(order.id)}
      />
    </FlexBox>
  )
})
